import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { VAM_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  Error,
  GetGitConnectionsResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  children?: (data: GetGitConnectionsResponse) => ReactElement
  onSuccess?: (data: GetGitConnectionsResponse) => void
  onError?: (error: Error) => void
  shortErrorMessage?: string
}

const GetGitConnectionsRequest = ({
  children,
  onSuccess,
  onError,
  shortErrorMessage
}: Props) => {
  const url = `${VAM_SERVICE}/repositories`

  const { requestParams } = useGetParamsWithSpaceId({})

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      onSuccess={onSuccess}
      params={requestParams}
      shortErrorMessage={shortErrorMessage}
      url={url}
    />
  )
}

export default GetGitConnectionsRequest
